import { Component, effect, inject, OnInit, ViewContainerRef, ComponentRef } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

import { BannerComponent } from 'app/_shared/components/factory/banner/banner.component'
import { PasswordComponent } from 'app/_shared/components/factory/password/password.component'
import { ProductListComponent } from 'app/_shared/components/factory/product-list/product-list.component'
import { RedirectTilesComponent } from 'app/_shared/components/factory/redirect-tiles/redirect-tiles.component'
import { TextEditorComponent } from 'app/_shared/components/factory/text-editor/text-editor.component'
import { TextWithImageComponent } from 'app/_shared/components/factory/text-with-image/text-with-image.component'
import { TitleComponent } from 'app/_shared/components/factory/title/title.component'
import { ComponentEnum, Page } from 'app/_shared/interfaces/config'
import { ConfigStore } from 'app/store/config.store'

@Component({
  selector: 'app-factory',
  imports: [],
  templateUrl: './factory.component.html',
  styleUrl: './factory.component.scss'
})
export class FactoryComponent implements OnInit {
  configStore = inject(ConfigStore)

  pageConfig: Page

  constructor(
    private route: ActivatedRoute,
    private viewContainer: ViewContainerRef
  ) {
    effect(() => {
      // Clear all views in this container
      this.viewContainer.clear()

      // Get the current page from the store
      const currentPage = this.configStore
        .config()
        ?.pages?.find(page => page.id === this.pageConfig?.id)
      if (currentPage?.hasPassword && !currentPage.allowedAccess) {
        const ref: ComponentRef<any> | undefined =
          this.viewContainer.createComponent(PasswordComponent)
        ref.setInput('page', currentPage)
      } else {
        // Loop through the current page's sections and create components
        currentPage?.sections.forEach(section => {
          let containerRef: ComponentRef<any> | undefined

          switch (section.component) {
            case ComponentEnum.TextArea:
              containerRef = this.viewContainer.createComponent(TextEditorComponent)
              break
            case ComponentEnum.TextWithImage:
              containerRef = this.viewContainer.createComponent(TextWithImageComponent)
              break
            case ComponentEnum.BannerImage:
              containerRef = this.viewContainer.createComponent(BannerComponent)
              break
            case ComponentEnum.ProductList:
              containerRef = this.viewContainer.createComponent(ProductListComponent)
              break
            case ComponentEnum.Title:
              containerRef = this.viewContainer.createComponent(TitleComponent)
              break
            case ComponentEnum.RedirectTiles:
              containerRef = this.viewContainer.createComponent(RedirectTilesComponent)
              break
          }

          if (containerRef) {
            // Pass the section data into the component as an input
            containerRef.setInput('section', section)
            // Wait for the child to render, then query its first div
            setTimeout(() => {
              const childDiv = containerRef.location.nativeElement.querySelector('div')
              if (childDiv) {
                childDiv.style.marginBottom = '1.5rem'
                if (section.component !== ComponentEnum.BannerImage) {
                  childDiv.style.marginTop = '1.5rem'
                  childDiv.classList.add('site-container')
                }
              }
            })
          }
        })
      }
    })
  }

  ngOnInit(): void {
    this.route.data?.subscribe(data => {
      this.pageConfig = data['pageConfig']
    })
  }
}
